import { CLIENT_CONTRACT } from "./lib/client_contract"

const mapSources = CLIENT_CONTRACT.mobile.mapSources
const tilePolicy = mapSources.tiles

export const OSM_ATTRIBUTION = tilePolicy.streets.attributionHtml
export const MAPLIBRE_STYLE_URL = mapSources.styleUrl

export const TILE_SOURCES = Object.freeze({
  streets: Object.freeze({
    leafletUrl: tilePolicy.streets.leafletUrl,
    mapLibreTiles: Object.freeze(tilePolicy.streets.mapLibreTiles),
    tileSize: tilePolicy.streets.tileSize,
    maxZoom: tilePolicy.streets.maxZoom,
    attribution: OSM_ATTRIBUTION
  }),
  satellite: Object.freeze({
    url: tilePolicy.satellite.url,
    tileSize: tilePolicy.satellite.tileSize,
    maxZoom: tilePolicy.satellite.maxZoom,
    attribution: tilePolicy.satellite.attribution
  }),
  topo: Object.freeze({
    url: tilePolicy.topo.url,
    tileSize: tilePolicy.topo.tileSize,
    maxZoom: tilePolicy.topo.maxZoom,
    maxNativeZoom: tilePolicy.topo.tileMaxZoom,
    mapLibreMaxZoom: tilePolicy.topo.mapLibreMaxZoom,
    attribution: tilePolicy.topo.webAttribution
  })
})

export function leafletTileConfig(key, overrides = {}) {
  const source = TILE_SOURCES[key]
  if (!source) return null
  return {
    url: source.leafletUrl || source.url,
    options: {
      maxZoom: source.maxZoom,
      ...(source.maxNativeZoom != null ? { maxNativeZoom: source.maxNativeZoom } : {}),
      attribution: source.attribution || "",
      ...overrides
    }
  }
}

export function mapLibreRasterSource(key) {
  const source = TILE_SOURCES[key]
  if (!source) return null
  return {
    type: "raster",
    tiles: source.mapLibreTiles || [source.url],
    tileSize: source.tileSize || 256,
    maxzoom: source.mapLibreMaxZoom ?? source.maxNativeZoom ?? source.maxZoom,
    ...(source.attribution ? { attribution: source.attribution } : {})
  }
}
